module.exports = {
          srcSet: __webpack_public_path__ + "0c433debc4afc014155064c6df3e6b8e-20.png"+" 20w",
          images:[ {path: __webpack_public_path__ + "0c433debc4afc014155064c6df3e6b8e-20.png",width: 20,height: 21}],
          src: __webpack_public_path__ + "0c433debc4afc014155064c6df3e6b8e-20.png",
          toString:function(){return __webpack_public_path__ + "0c433debc4afc014155064c6df3e6b8e-20.png"},
          
          width: 20,
          height: 21
        }